import './styles.scss'

const TriangleAvatarsFormation = ({ avatars }) => {
  return (
    <div className="avatars_triangle_formation">
      {avatars.map((avatar) => (
        <div key={avatar.id} className="avatar_in_triangle">
          {avatar.content}
        </div>
      ))}
    </div>
  )
}

export default TriangleAvatarsFormation
